import api from '../utils/api';

export const getContestList = (config = {}) => {
    const { data, options } = config;
    return api({
        url: '/api/contest/getAll',
        method: "POST",
        data: data,
        ...options,
    });
};
export const getContestByBaseId = (contestBaseId) => {
    return api({
        url: '/api/contest/getContestByBaseId/' + contestBaseId,
        method: 'GET'
    })
}
export const addUpdateContest = (contest) => {
    let url = '/api/contest/addUpdateContest';
    return api({
        url: url,
        method: 'POST',
        data: contest
    })
}

export const deleteContest = (config = {}) => {
    const { data, options } = config;
    return api({
        url: `api/contest/deleteContest/${data}`,
        method: "DELETE",
        data: data,
        ...options,
    });
}

export const getContestTypes = (config = {}) => {
    const { options } = config;
    return api({
        url: '/api/contest/getContestTypes',
        method: 'GET',
        ...options,
    });
}; 

export const updateContestOrder = (config = {}) => {
    const { options } = config;
    return api({
        url: 'api/contest/order',
        method: 'POST',
        ...options,
    });
}
